import React, { useState, useEffect } from 'react';
import { Row, Col, Card, CardBody, Button } from 'reactstrap';
import axios from 'axios';

export function AlertPhotos() {
  const [photos,        setPhotos]       = useState([]);
  const [currentPhoto,  setCurrentPhoto] = useState(null);

  const [manufacturer,  setManufacturer] = useState('');
  const [shingleType,   setShingleType]  = useState('');
  const [color,         setColor]        = useState('');

  const [rotation,      setRotation]     = useState(0);  // NEW

  const [sortConfig,    setSortConfig]   = useState({ key: 'name', direction: 'asc' });

  // Dynamic dropdowns
  const [manufacturers,     setManufacturers]   = useState([]);
  const [products,          setProducts]        = useState([]);
  const [availableColors,   setAvailableColors] = useState([]);

  /* --------------- INITIAL LOAD --------------- */
  useEffect(() => {
    fetchPhotos();
    loadManufacturers();
  }, []);

  const fetchPhotos = async () => {
    try {
      const token = localStorage.getItem('idToken');
      const res   = await axios.get('http://localhost:8001/api/photos/alert', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPhotos(res.data);
    } catch (error) {
      console.error('Error fetching alert photos:', error);
    }
  };

  const loadManufacturers = async () => {
    try {
      const res = await axios.get('http://localhost:8001/api/shingles/manufacturers');
      setManufacturers(res.data.manufacturers);
    } catch (error) {
      console.error('Error fetching manufacturers:', error);
    }
  };

  const loadProducts = async (selectedManufacturer, pre = null) => {
    try {
      const res = await axios.get('http://localhost:8001/api/shingles/products', {
        params: { manufacturer: selectedManufacturer },
      });
      let list  = res.data.products;
      if (pre && !list.includes(pre)) list = [pre, ...list];
      setProducts(list);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const loadColors = async (selectedProduct, pre = null) => {
    try {
      const res = await axios.get('http://localhost:8001/api/shingles/colors', {
        params: { product: selectedProduct },
      });
      let list = res.data.colors;
      if (pre && !list.includes(pre)) list = [pre, ...list];
      setAvailableColors(list);
    } catch (error) {
      console.error('Error fetching colors:', error);
    }
  };

  /* --------------- ROTATION --------------- */
  const rotateLeft  = () => setRotation((prev) => (prev + 270) % 360);
  const rotateRight = () => setRotation((prev) => (prev + 90)  % 360);

  /* --------------- PHOTO SELECT --------------- */
  const preselectFields = async (photo) => {
    if (photo.manufacturer) {
      setManufacturer(photo.manufacturer);
      await loadProducts(photo.manufacturer, photo.shingle_type);

      if (photo.shingle_type) {
        setShingleType(photo.shingle_type);
        await loadColors(photo.shingle_type, photo.color);
        setColor(photo.color || '');
      } else {
        setShingleType(''); setColor('');
      }
    } else {
      setManufacturer(''); setShingleType(''); setColor('');
    }
  };

  const handlePhotoClick = async (photo) => {
    setCurrentPhoto(photo);
    setRotation(photo.orientation || 0);
    await preselectFields(photo);
  };

  /* --------------- FORM HANDLERS --------------- */
  const handleManufacturerChange = (e) => {
    const val = e.target.value;
    setManufacturer(val);
    setShingleType(''); setColor('');
    setProducts([]);    setAvailableColors([]);
    if (val) loadProducts(val);
  };

  const handleProductChange = (e) => {
    const val = e.target.value;
    setShingleType(val);
    setColor('');
    setAvailableColors([]);
    if (val) loadColors(val);
  };

  /* --------------- SORTING --------------- */
  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const sortedPhotos = [...photos].sort((a, b) => {
    const { key, direction } = sortConfig;
    const order = direction === 'asc' ? 1 : -1;
    if (a[key] < b[key]) return -1 * order;
    if (a[key] > b[key]) return 1 * order;
    return 0;
  });

  /* --------------- SAVE --------------- */
  const handleLabelPhoto = async () => {
    if (!currentPhoto) return;
    try {
      const token = localStorage.getItem('idToken');
      await axios.post(
        `http://localhost:8001/api/photos/${currentPhoto.id}/label`,
        {
          username:      localStorage.getItem('username'),
          label:         'Label',
          manufacturer,
          shingle_type:  shingleType,
          color,
          orientation:   rotation,              // NEW
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      fetchPhotos();               // refresh counts / status
    } catch (error) {
      console.error('Error labeling photo:', error);
    }
  };

  /* =============== RENDER =============== */
  return (
    <div className="page-content">
      <Row>
        <Col xs={12}>
          <div className="page-title-box d-flex align-items-center justify-content-between">
            <h4 className="mb-0">Alert Photos for Audit</h4>
          </div>
        </Col>
      </Row>

      <Row>
        {currentPhoto && (
          <Col md={5}>
            <Card>
              <CardBody>
                {/* Image + Rotation */}
                <div className="d-flex justify-content-center align-items-center mb-3">
                  <Button color="secondary" className="me-2" onClick={rotateLeft}>
                    <i className="mdi mdi-rotate-left"></i>
                  </Button>
                  <img
                    src={currentPhoto.url}
                    alt={currentPhoto.name}
                    className="img-fluid"
                    style={{
                      transform:  `rotate(${rotation}deg)`,
                      transition: 'transform 0.25s ease',
                      maxHeight:  '60vh',
                    }}
                  />
                  <Button color="secondary" className="ms-2" onClick={rotateRight}>
                    <i className="mdi mdi-rotate-right"></i>
                  </Button>
                </div>

                {/* Dropdowns */}
                <div className="mb-2">
                  <select value={manufacturer} onChange={handleManufacturerChange} className="form-select">
                    <option value="" disabled>Manufacturer</option>
                    {manufacturers.map((m, i) => <option key={i} value={m}>{m}</option>)}
                  </select>
                </div>
                <div className="mb-2">
                  <select value={shingleType} onChange={handleProductChange} className="form-select">
                    <option value="" disabled>Product Name</option>
                    {products.map((p, i) => <option key={i} value={p}>{p}</option>)}
                  </select>
                </div>
                <div className="mb-3">
                  <select value={color} onChange={(e) => setColor(e.target.value)} className="form-select">
                    <option value="" disabled>Color</option>
                    {availableColors.map((c, i) => <option key={i} value={c}>{c}</option>)}
                  </select>
                </div>

                <Button color="primary" onClick={handleLabelPhoto}>Submit Label &amp; Orientation</Button>
              </CardBody>
            </Card>
          </Col>
        )}

        {/* Table */}
        <Col md={currentPhoto ? 7 : 12}>
          <Card>
            <CardBody>
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
                        Photo Name&nbsp;
                        {sortConfig.key === 'name' && (
                          sortConfig.direction === 'asc'
                            ? <i className="mdi mdi-chevron-up"></i>
                            : <i className="mdi mdi-chevron-down"></i>
                        )}
                      </th>
                      <th onClick={() => handleSort('upload_timestamp')} style={{ cursor: 'pointer' }}>
                        Upload Date&nbsp;
                        {sortConfig.key === 'upload_timestamp' && (
                          sortConfig.direction === 'asc'
                            ? <i className="mdi mdi-chevron-up"></i>
                            : <i className="mdi mdi-chevron-down"></i>
                        )}
                      </th>
                      <th onClick={() => handleSort('username')} style={{ cursor: 'pointer' }}>
                        Uploaded By&nbsp;
                        {sortConfig.key === 'username' && (
                          sortConfig.direction === 'asc'
                            ? <i className="mdi mdi-chevron-up"></i>
                            : <i className="mdi mdi-chevron-down"></i>
                        )}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedPhotos.map((photo) => (
                      <tr key={photo.id} onClick={() => handlePhotoClick(photo)} style={{ cursor: 'pointer' }}>
                        <td>{photo.name}</td>
                        <td>{new Date(photo.upload_timestamp).toLocaleString()}</td>
                        <td>{photo.username}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default AlertPhotos;

